import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { environment } from 'src/environments/environment';
import { CurrentUserService } from '../current-user.service';
import { flatMap, map } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class FileService {
	private loggedInUser: any;
	private fileType: 'qp'; // TODO:
	constructor(private apiService: ApiService,
		private currentUserService: CurrentUserService) {
		this.loggedInUser = this.currentUserService.getCurrentUserLocal().value;
	}
	private getFileUploadCredentials(key) {
		const fileUploadCredentialsURL = `${environment.documentServiceUrl}/api/document/v1`;
		return this.apiService.get(fileUploadCredentialsURL, {
			key
		});
	}
	private uploadFileToS3(file, path, credentials) {
		const formData = new FormData();
		formData.append('key', `${path}/${credentials.Uuid}/${file.name}`);
		formData.append('acl', 'private');
		formData.append('Content-Type', 'image/');
		formData.append('x-amz-meta-uuid', '1436512365127qw');
		formData.append('x-amz-server-side-encryption', 'AES256');
		formData.append('x-amz-credential', `${credentials.Key}/${this.buildTimestamp()}/ap-south-1/s3/aws4_request`);
		formData.append('x-amz-algorithm', 'AWS4-HMAC-SHA256');
		formData.append('x-amz-date', `${this.buildTimestamp()}T000000Z`);
		formData.append('x-amz-meta-tag', '');
		formData.append('policy', credentials.Policy);
		formData.append('x-amz-signature', credentials.Signature);
		formData.append('file', file);
		const S3DocumentUploadURL = 'http://' + credentials.Bucket + '.s3.amazonaws.com/';
		return this.apiService.fileUpload(S3DocumentUploadURL, formData, true);
	}

	public uploadToServerV2(file: File, types: string, size: number, fType?: String) {
		if (!this.loggedInUser) {
			return this.currentUserService.getAdditionalInfomartion().pipe(map(data => {
				this.loggedInUser = data;
				return this.uploadToV2Server(file, types, size, fType);
			}));
		}
		return this.uploadToV2Server(file, types, size, fType);
	}

	uploadToV2Server(file: File, types: string, size: number, fType?: String) {
		let key;
		if (fType) {
			 key =
			this.loggedInUser.role +
			'/' +
			this.loggedInUser.userName +
			'/' +
			fType;
		} else {
			 key =
			this.loggedInUser.role +
			'/' +
			this.loggedInUser.userName +
			'/' +
			this.fileType;
		}
		const contentType = file.type;
		const formData = this._createFormDataV2({
			file,
			types,
			size,
			contentType,
			path: key
		});
		const URL = `${environment.documentServiceUrl}/api/document/v2`;
		// const URL = `${environment.documentServiceUrl}/api/document/v1`;
		return this.apiService.fileUpload(URL, formData).pipe(map(res => res.body));
		// .map(url => {
		// url = {
		// 	link: url
		// };
		// return url;
		// if (url.indexOf('/') >= 0) {
		// 	// url = url.split('/').pop();
		// 	url = encodeURI(url);

		// }
		// return url;
		// });
	}


	private _createFormDataV2(data) {
		const formData = new FormData();
		if (data && data instanceof Object) {
			for (const key in data) {
				formData.append(key, data[key]);
			}
		}
		return formData;
	}
	private buildTimestamp() {
		const date = new Date();
		const year = date.getFullYear();
		const month = ('0' + (date.getMonth() + 1)).slice(-2);
		const day = ('0' + date.getDate()).slice(-2);
		const timestamp = year + month + day;
		return timestamp;
	}
	uploadFile(key, file, type?, size?) {
		return this.getFileUploadCredentials(key)
			.pipe(flatMap((credentials) => {
				return this.uploadFileToS3(file, key, credentials);
			}));
	}

	public uploadToServerV3(file: File, types: string, size: number) {
		const contentType = file.type;
		const formData = this._createFormDataV2({
			file,
			types,
			size,
			contentType
		});
		const URL = `${environment.documentServiceUrl}/api/document/v3`;
		// const URL = `${environment.documentServiceUrl}/api/document/v1`;
		return this.apiService.fileUpload(URL, formData).pipe(map(res => res.body));
	}
	public uploadToServerV4(file: File, types: string, size: number) {
		const contentType = file.type;
		const formData = this._createFormDataV2({
			file,
			types,
			size,
			contentType,
			path: 'Candidate'
		});
		const URL = `${environment.documentServiceUrl}/api/document/v3?role=Candidate`;
		// const URL = `${environment.documentServiceUrl}/api/document/v3`;
		// const URL = `${environment.documentServiceUrl}/api/document/v1`;
		return this.apiService.fileUpload(URL, formData).pipe(map(res => res.body));
	}
}
